import React from 'react';
import { useSelector } from 'react-redux';

// Images
import ZoomInfoIcon1 from 'Shared/images/zoom-welcome-1.svg';
import ZoomInfoIcon2 from 'Shared/images/zoom-welcome-2.svg';
import ZoomInfoIcon3 from 'Shared/images/zoom-welcome-3.svg';

// Selectors
import * as OnboardingStateSelectors from 'Shared/selectors/OnboardingState.selectors';

// Components
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';

// Types
import { OnboardingWizardStep } from '../../types';

// Styles
import './ZoomStartScreen.scss';

type Props = {
  handleInviteClick: () => void;
  handleSkip: () => void;
};

const ZoomStartScreen = ({ handleInviteClick, handleSkip }: Props) => {
  const profile = useSelector(state => OnboardingStateSelectors.getProfile(state));
  const step = useSelector(state => OnboardingStateSelectors.getStep(state));

  const isInvited = step === OnboardingWizardStep.zoomProfile;

  const name = profile.fullName.split(' ')[0];

  const baseClassName = 'ZoomStartScreen';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__title`}>
        <h4>Welcome {name}</h4>
        <p className={`${baseClassName}__title__subtitle`}>Let’s get started, here is what to expect</p>
      </div>
      <div className={`${baseClassName}__info-blocks`}>
        <div className={`${baseClassName}__info-blocks__block`}>
          <img className={`${baseClassName}__info-blocks__block__img`} src={ZoomInfoIcon1} />
          <div className={`${baseClassName}__info-blocks__block__desc`}>
            Build collaborative agendas so everyone shows up prepared
          </div>
        </div>
        <div className={`${baseClassName}__info-blocks__block`}>
          <img className={`${baseClassName}__info-blocks__block__img`} src={ZoomInfoIcon2} />
          <div className={`${baseClassName}__info-blocks__block__desc`}>
            Have productive meetings, make decisions and assign next steps
          </div>
        </div>
        <div className={`${baseClassName}__info-blocks__block`}>
          <img className={`${baseClassName}__info-blocks__block__img`} src={ZoomInfoIcon3} />
          <div className={`${baseClassName}__info-blocks__block__desc`}>
            Keep your workflow going until your next awesome meeting
          </div>
        </div>
      </div>
      <div className={`${baseClassName}__footer`}>
        {isInvited ? (
          <>
            <h5 className={`${baseClassName}__footer__title`}>Ready to start collaborating?</h5>
            <WpButton onClick={handleSkip} size="lg" block>
              Go to Workspace
            </WpButton>
          </>
        ) : (
          <>
            <h5 className={`${baseClassName}__footer__title`}>Try PI Perform with a coworker</h5>
            <WpButtonGroup spacing="md" stacked block>
              <WpButton onClick={handleInviteClick} size="lg" block>
                <WpIcon name="plus-circle" />
                Add Teammate
              </WpButton>
              <WpButton variant="tertiary" size="lg" onClick={handleSkip} block>
                Skip for now
              </WpButton>
            </WpButtonGroup>
          </>
        )}
      </div>
    </div>
  );
};

export default ZoomStartScreen;
